import { combineReducers } from "redux";
import { reducerAnimations } from "../features/animation/reducerAnimations";
import { reducerChatInfo } from "../features/chat/reducerChatInfo";
import { reducerCheats } from "../features/cheats/reducerCheats";
import { reducerCoopInfoReceived } from "../features/cooperative/reducerCoopInfo";
import { reducerDependencyInjection } from "../features/dep-injection/reducerDependencyInjection";
import { reducerDiscountEvent } from "../features/discount-event/reducerDiscountEvent";
import { reducerDoghouse } from "../features/doghouse/reducerDoghouse";
import { reducerEnvSelect } from "../features/env-select/reducerEnvSelect";
import { reducerError } from "../features/errors/reducerError";
import { reducerFacebook } from "../features/facebook/reducerFacbookConnect";
import { reducerFortuneTellerEventInfo } from "../features/fortune-teller-event/reducerFortuneTellerEventInfo";
import { reducerGrantRewards } from "../features/grant-rewards/reducerGrantRewards";
import { reducerActionButtonIterations } from "../features/hud-action-button/reducerActionButtons";
import { reducerBalloonInfo } from "../features/info/balloon/reducerBalloonInfo";
import { reducerBaseInfoReceived } from "../features/info/base/reducerBaseInfo";
import { reducerEventInfo } from "../features/info/event/reducerEventInfo";
import { reducerInventoryInfoReceived } from "../features/info/inventory/reducerInventoryInfo";
import { reducerLeagueInfoReceived } from "../features/info/league/reducerPlayerLeagueInfo";
import { reducerOutskirtsInfo } from "../features/info/outskirts/reducerOutskirtsInfo";
import { reducerPaymentEntryInfoReceived } from "../features/info/payment-entry-info/reducerPaymentEntryInfo";
import { reducerPlayerSettingsInfo } from "../features/info/player-settings/reducerPlayerSettingsInfo";
import { reducerPlayerInfoReceived } from "../features/info/player/reducerPlayerInfo";
import { reducerProductionInfoReceived } from "../features/info/production/reducerProductionInfo";
import { reducerPurchasePackageInfoReceived } from "../features/info/purchase-packages/reducerPackageInfo";
import { reducerQuestInfoReceived } from "../features/info/quest/reducerQuestInfo";
import { reducerSubscriptionInfo } from "../features/info/subscription/reducerSubscriptionInfo";
import { reducerLimitedActionInfo } from "../features/limited-action-info/reducerLimitedActionInfo";
import { reducerLoading } from "../features/loading/reducerLoading";
import { reducerLoca } from "../features/loca/reducerLoca";
import { reducerContractInfo } from "../features/market/reducerContractInfo";
import { createReducerModals } from "../features/modals/createReducerModals";
import { modals } from "../features/modals/modals";
import { reducerNetwork } from "../features/network/reducerNetwork";
import { reducerOngoingPurchase } from "../features/ongoing-purchase/reducerOngoingPurchase";
import { reducerPendingInventoryInfo } from "../features/pending-inventory/reducerPendingInventory";
import { reducerPlayerBase } from "../features/player-base/reducerPlayerBase";
import { reducerSelectedPlayerProfile } from "../features/player-profile/reducerSelectedPlayerProfile";
import { reducerPurchasePointsEventInfo } from "../features/purchase-points-event/reducerPurchasePointsEventInfo";
import { reducerPVP } from "../features/pvp/reducerPvp";
import { reducerQuickSell } from "../features/quick-sell-dialog/reducerQuickSell";
import { reducerPlayerRank } from "../features/ranking/reducerPlayerRank";
import { createReducerScenes } from "../features/scenes/createReducerScenes";
import { scenes } from "../features/scenes/scenes";
import { reducerShop } from "../features/shop/reducerShop";
import { reducerShowMe } from "../features/show-me/reducerShowMe";
import { reducerStore } from "../features/store/reducerStore";
import { reducerThemedEvent } from "../features/themed-events/reducerThemedEvent";
import { reducerTooltip } from "../features/tooltip/reducerTooltip";
import { reducerLeagueRanking } from "../features/tournament-building/reducerLeagueRanking";
import { reducerOngoingLeagueReward } from "../features/tournament-building/reducerOngoingLeagueRewardInfo";
import { reducerTraderEventInfo } from "../features/trader-event/reducerTraderEventInfo";
import { reducerTutorial } from "../features/tutorial/reducerTutorial";
import { reducerViewport } from "../features/viewport/reducerViewport";
export var rootReducerMap = {
    actionButtonInfos: reducerActionButtonIterations,
    animations: reducerAnimations,
    balloonInfo: reducerBalloonInfo,
    baseInfo: reducerBaseInfoReceived,
    chatInfo: reducerChatInfo,
    cheats: reducerCheats,
    contractInfo: reducerContractInfo,
    coopInfo: reducerCoopInfoReceived,
    dependencies: reducerDependencyInjection,
    discountEvent: reducerDiscountEvent,
    doghouse: reducerDoghouse,
    environment: reducerEnvSelect,
    errors: reducerError,
    eventInfo: reducerEventInfo,
    facebookConnectInfo: reducerFacebook,
    fortuneTellerEventInfo: reducerFortuneTellerEventInfo,
    grantRewards: reducerGrantRewards,
    inventoryInfo: reducerInventoryInfoReceived,
    leagueInfo: reducerLeagueInfoReceived,
    leagueRanking: reducerLeagueRanking,
    limitedActionInfo: reducerLimitedActionInfo,
    loading: reducerLoading,
    loca: reducerLoca,
    modals: createReducerModals(modals),
    network: reducerNetwork,
    ongoingLeagueReward: reducerOngoingLeagueReward,
    ongoingPurchase: reducerOngoingPurchase,
    outskirtsInfo: reducerOutskirtsInfo,
    packageInfo: reducerPurchasePackageInfoReceived,
    paymentInfo: reducerPaymentEntryInfoReceived,
    pendingInventoryInfo: reducerPendingInventoryInfo,
    playerBase: reducerPlayerBase,
    playerInfo: reducerPlayerInfoReceived,
    playerRanking: reducerPlayerRank,
    playerSettingsInfo: reducerPlayerSettingsInfo,
    productionInfo: reducerProductionInfoReceived,
    purchasePointsEventInfo: reducerPurchasePointsEventInfo,
    pvp: reducerPVP,
    questInfo: reducerQuestInfoReceived,
    quickSellInfo: reducerQuickSell,
    scenes: createReducerScenes(scenes),
    selectedPlayerProfile: reducerSelectedPlayerProfile,
    shop: reducerShop,
    showMe: reducerShowMe,
    storeInfo: reducerStore,
    subscriptionInfo: reducerSubscriptionInfo,
    themedEventInfo: reducerThemedEvent,
    tooltip: reducerTooltip,
    traderEventInfo: reducerTraderEventInfo,
    tutorial: reducerTutorial,
    viewport: reducerViewport,
};
export var rootReducer = combineReducers(rootReducerMap);



//////////////////
// WEBPACK FOOTER
// ./src/setup/rootReducer.ts
// module id = 2518
// module chunks = 3